export const style = {
    buttonLoaderClass: "kt-spinner kt-spinner--left kt-spinner--sm kt-spinner--light disabled",
};
